export default __webpack_public_path__ + "static/media/fr.555cf854.svg";